module.exports = __webpack_public_path__ + "static/media/plus-blue.62648db9.svg";